import { ComponentProps, FC, PropsWithChildren } from 'react';

import { Box } from '@bonusly/design-system';

interface UserSpotlightCardShellProps extends PropsWithChildren {
	/**
	 * Optional override for the inner "content" card padding (the solid surface).
	 */
	innerPadding?: ComponentProps<typeof Box>['p'];
}

export const UserSpotlightCardShell: FC<UserSpotlightCardShellProps> = ({ children, innerPadding = { base: 8, md: '60px' } }) => {
	return (
		<Box
			borderRadius="3xl"
			bg="bg.minipage"
			backdropFilter="blur(20px)"
			p="15px"
			sx={{
				WebkitBackdropFilter: 'blur(20px)',
			}}
		>
			<Box bg="bg.surface" borderRadius="2xl" p={innerPadding} display="flex" flexDirection="column" justifyContent="center" position="relative">
				{children}
			</Box>
		</Box>
	);
};
